import CancellableHelper from "@/requests/CancellableHelper";
import { SelectItem } from "@/models/api/SelectItem";

//Routes
export const URL_GET_USER_CREDIT_CARDS = "/CreditCard/User";

//Requests
const _getUserCreditCards = new CancellableHelper<Array<SelectItem>>(URL_GET_USER_CREDIT_CARDS, SelectItem);
export const getUserCreditCards = async (): Promise<Array<SelectItem>> => {
  return _getUserCreditCards.get();
};
